import { render } from "./SetAvatar.vue?vue&type=template&id=082e05b6&scoped=true"
import script from "./SetAvatar.vue?vue&type=script&lang=js"
export * from "./SetAvatar.vue?vue&type=script&lang=js"

import "./SetAvatar.vue?vue&type=style&index=0&id=082e05b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082e05b6"]])

export default __exports__